import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getCurrentAnnouncementKey = (): UseDataQuery['queryKey'] => ['announcements-current'];

export const getFindAnnouncementsKey = (): UseDataQuery['queryKey'] => ['announcements'];

export const getAnnouncementKey = (announcementId: string): UseDataQuery['queryKey'] => [
  'announcements',
  undefined,
  { announcementId },
];
